import React, { createContext, useContext, useState, useEffect } from "react";

import { useLocation } from "react-router-dom";
import { lexisPlusServices } from "services/lexis";

const LandingStylingContext = createContext();

const useLandingStyling = () => useContext(LandingStylingContext);

const DEFAULT = {
  isLanding: true,
};

const landingPaths = [
  "/",
  "/court-judge-compare",
  "/counsel-compare",
  "/early-case-assessor",
  "/party-group-editor",
];

function LandingStylingProvider(props) {
  const [isLanding, setIsLanding] = useState(DEFAULT.isLanding);
  const { pathname } = useLocation();
  useEffect(() => {
    if (landingPaths.includes(pathname)) {
      setIsLanding(true);
      lexisPlusServices.enterLandingPage();
    } else {
      setIsLanding(false);
      lexisPlusServices.leaveLandingPage();
    }
  }, [isLanding, pathname]);
  return (
    <LandingStylingContext.Provider value={isLanding}>
      {props.children}
    </LandingStylingContext.Provider>
  );
}

export { LandingStylingProvider, useLandingStyling };
